import { EndlessOfferTracker } from "interfaces/endless-offer";
import { getVariantImage } from "helpers/getVariantImage";

export const getClassByNodesCount = (nodes: number) => {
	if (nodes > 5) {
		return "several-nodes";
	}
	return "";
};

export const getBackgroundUrl = (url: string, isPortrait: boolean) => {
	return getVariantImage(
		url,
		"{endless_offer_variant}",
		isPortrait ? "small" : "large"
	);
};

export const getThemeConfig = (
	tracker?: EndlessOfferTracker,
	isPortrait = false
) => {
	if (!tracker) {
		return undefined;
	}
	const config = tracker?.themeConfig;
	return {
		bgImageUrl: getBackgroundUrl(
			config?.themeBackgroundImageUrl ?? tracker.themeBackgroundImageUrl,
			isPortrait
		),
		secondaryBgImageUrl: config?.secondaryBackgroundImageUrl
			? getBackgroundUrl(config.secondaryBackgroundImageUrl, isPortrait)
			: undefined,
		titleImageUrl: config?.titleImageUrl ?? tracker.titleImageUrl,
		nodeBgImageUrl: getBackgroundUrl(
			config?.nodeBackgroundImageUrl ?? tracker.nodeBackgroundImageUrl,
			isPortrait
		),
		nodeSuperOfferBgImageUrl: getBackgroundUrl(
			config?.nodeSuperOfferBackgroundImageUrl ??
				tracker.nodeSuperOfferBackgroundImageUrl,
			isPortrait
		),
		nodeBadgeRibbonImageUrl:
			config?.nodeBadgeRibbonImageUrl ?? tracker.nodeBadgeRibbonImageUrl,
		nodeSuperOfferBadgeRibbonImageUrl:
			config?.nodeSuperOfferBadgeRibbonImageUrl ??
			tracker.nodeSuperOfferBadgeRibbonImageUrl,
		nodeBgLockedImageUrl: getBackgroundUrl(
			config?.nodeLockedBackgroundImageUrl ?? "",
			isPortrait
		),
		nodeSuperOfferLockedBgImageUrl: getBackgroundUrl(
			config?.nodeSuperOfferLockedBackgroundImageUrl ?? "",
			isPortrait
		),
		ropeImageUrlThreeNodes: getBackgroundUrl(config?.ropeImageUrl ?? "", false),
		ropeImageUrlSixNodes: getBackgroundUrl(config?.ropeImageUrl ?? "", true)
	};
};
